/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Tiers } from '../../models/tiers';

export interface GetLoyaltyProgramTiers$Params {
  'Active-Tenant-Identifier': string;
  programId: string;
}

export function getLoyaltyProgramTiers(http: HttpClient, rootUrl: string, params: GetLoyaltyProgramTiers$Params, context?: HttpContext): Observable<StrictHttpResponse<Tiers>> {
  const rb = new RequestBuilder(rootUrl, getLoyaltyProgramTiers.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('programId', params.programId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Tiers>;
    })
  );
}

getLoyaltyProgramTiers.PATH = '/loyalty/programs/{programId}/tiers';
